module.exports = __webpack_public_path__ + "static/media/MeninasDoceiras-Logo.43dab23b.png";